export const styles = {
  baseCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    margin: 1,
  },
}
